import { createTypedAsyncThunk, withOrgId } from "../utils/actions";
import * as API from "@/data/api/roles";
import {
  RequestParams,
  TRoleItem,
  TCreateRolePayload,
  TUpdateRolePayload,
  TRoleItemWithPerms,
} from "@/data/types";
import { State } from "../state/state";

export const getAllRolesAsync = createTypedAsyncThunk<
  { items: TRoleItem[] },
  RequestParams,
  { state: State }
>("roles/getAllRoles", async (params, { getState }) => {
  return API.getAllRoles(withOrgId(getState, params));
});

export const createRoleAsync = createTypedAsyncThunk<
  TRoleItem,
  { params?: RequestParams; payload: TCreateRolePayload },
  { state: State }
>("roles/createRole", async ({ params = {}, payload }, { getState }) => {
  return API.createRole(withOrgId(getState, params), payload);
});

export const getRoleByIdAsync = createTypedAsyncThunk<
  {items: TRoleItemWithPerms[]},
  { roleId: string; params?: RequestParams },
  { state: State }
>("roles/getRoleById", async ({ roleId, params = {} }, { getState }) => {
  return API.getRoleById(roleId, withOrgId(getState, params));
});

export const updateRoleAsync = createTypedAsyncThunk<
  TRoleItem,
  {
    roleId: string;
    params?: RequestParams;
    payload: Partial<TUpdateRolePayload>;
  },
  { state: State }
>(
  "roles/updateRole",
  async ({ roleId, params = {}, payload }, { getState }) => {
    return API.updateRole(roleId, withOrgId(getState, params), payload);
  }
);

export const deleteRoleAsync = createTypedAsyncThunk<
  { success: boolean },
  { roleId: string; params?: RequestParams },
  { state: State }
>("roles/deleteRole", async ({ roleId, params = {} }, { getState }) => {
  return API.deleteRole(roleId, withOrgId(getState, params));
});
